import { render, staticRenderFns } from "./StatusPeriodo.vue?vue&type=template&id=9944df16&"
import script from "./StatusPeriodo.vue?vue&type=script&lang=js&"
export * from "./StatusPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports